import { zonedTimeToUtc, utcToZonedTime, format } from "date-fns-tz";
import { TIMEZONE } from "config/headers";
const militarDateTimeFormat = "MM/dd/yyyy HH:mm";

export const standardDateTimeFormat = "MM/dd/yyyy hh:mm a";
export const standardDateFormat = "MM/dd/yyyy";

export const eventDateTimeFormat = "MMMM dd, yyyy h:mm a";
export const eventTimeFormat = "h:mm a";

export const convertToUTC = (dateTime: Date | undefined): Date | undefined => {
  if (dateTime) {
    return new Date(
      format(zonedTimeToUtc(dateTime, TIMEZONE!), militarDateTimeFormat)
    );
  }
  return undefined;
};

export const convertToZonedDate = (
  dateTime: Date | undefined
): Date | undefined => {
  if (dateTime) {
    return new Date(
      format(utcToZonedTime(dateTime, TIMEZONE!), standardDateFormat)
    );
  }
  return undefined;
};

export const dateToStandardFormat = (dateTime: Date): string => {
  return format(dateTime, standardDateTimeFormat);
};

export const convertDateTimeTo12hrFormat = (
  dateTime?: Date
): Date | undefined => {
  return dateTime
    ? new Date(format(dateTime, standardDateTimeFormat))
    : undefined;
};

export const addDays = (dateTime?: Date, days?: number): Date | undefined => {
  if (!dateTime || !days) return undefined;

  dateTime.setDate(dateTime.getDate() + days);
  return dateTime;
};

export const setTimeToMidNight = (dateTime?: Date): Date | undefined => {
  if (dateTime) {
    dateTime.setHours(0, 0, 0, 0);
    return dateTime;
  }

  return undefined;
};

export const setTimeToEndOfDay = (dateTime?: Date): Date | undefined => {
  if (dateTime) {
    dateTime.setHours(23, 59, 59, 0);
    return dateTime;
  }

  return undefined;
};

export const getPreviousDay = (date: Date | undefined): Date | undefined => {
  if (!date) {
    return undefined;
  }

  const previous = new Date(date?.getTime());
  previous.setDate(date?.getDate() - 1);

  return previous;
};

export const subtractHours = (date: Date, hours: number): Date | undefined => {
  if (!date) {
    return undefined;
  }

  date.setHours(date?.getHours() - hours);

  return date;
};
